import { TFunction } from 'i18next'
import React, { useMemo } from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import { ResponsiveContainer, ComposedChart, YAxis, XAxis } from 'recharts'
import { getMeasureColorForValue } from '../../_constants/colors'
import { getMeasureValueSegments, InfluxSeriesMeasuresData } from '@mv-submodules/inplant-plantanalysis-fe-iblu/functions/sharedV2'
import {
  TimeRangeColoredSegment,
  generateTimeRangeColoredArea,
} from '@mv-submodules/inplant-plantanalysis-fe-iblu/functions/sharedV2'

export interface OwnProps {
  data: InfluxSeriesMeasuresData
  t: TFunction
  topMargin?: boolean
  measureSlug: string
  paddingRight?: number
  lineHeight?: number
}

const i18nTitle = 'plantAnalysis.labels'

type Props = WithTranslation & OwnProps

const GenericTimeBarGraph = (props: Props) => {
  const { measureSlug, data, lineHeight, paddingRight, t, topMargin } = props

  const dataAreas = useMemo<TimeRangeColoredSegment[]>(() => {
    const dataPoints = getMeasureValueSegments(data, measureSlug)
    return dataPoints.map(segment => {
      const color = getMeasureColorForValue(measureSlug, segment.value)
      return {
        start: segment.start,
        end: segment.end,
        color,
      }
    })
  }, [measureSlug, data])


  const barDataComponents = useMemo(() => generateTimeRangeColoredArea({ segments: dataAreas }), [dataAreas])

  return (
    <div className={'row row-bar-chart row-bar-chart' + (topMargin ? '-under' : '')}>
      <div className="col-md-10" style={paddingRight ? { paddingRight } : {}}>
        <h5>{t(`${i18nTitle}.${measureSlug}`)}</h5>
        <ResponsiveContainer width="100%" height={lineHeight ? lineHeight : 20}>
          <ComposedChart width={700} height={180} data={data} barGap={0} barCategoryGap={0}>
            <YAxis label={''} domain={[0, 100]} tick={false} axisLine={false} tickLine={false} />
            <XAxis dataKey="time" hide={true} domain={['dataMin', 'dataMax']} type={'number'} interval={0} />
            {barDataComponents}
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

export default withTranslation()(GenericTimeBarGraph)
